import { render, staticRenderFns } from "./DocsHero.vue?vue&type=template&id=6583ad04&scoped=true"
import script from "./DocsHero.vue?vue&type=script&lang=js"
export * from "./DocsHero.vue?vue&type=script&lang=js"
import style0 from "./DocsHero.vue?vue&type=style&index=0&id=6583ad04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6583ad04",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow,VSpacer})
